import { render, staticRenderFns } from "./RechargePrepaid_old.vue?vue&type=template&id=06f07545&scoped=true&"
import script from "./RechargePrepaid_old.vue?vue&type=script&lang=js&"
export * from "./RechargePrepaid_old.vue?vue&type=script&lang=js&"
import style0 from "./RechargePrepaid_old.vue?vue&type=style&index=0&id=06f07545&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f07545",
  null
  
)

export default component.exports